module.exports = __webpack_public_path__ + "img/type_text.af9895dc.png";